import React, { useState } from 'react';
import moment from 'moment';
import Container from '@material-ui/core/Container';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { LoadingBar } from '../common';
import { fetchWrap as fetch, getLangValue, formatCurrency } from '../common/functions';
import config from '../config';

import User from '../users/User';

const stateMap = {
    'played': 'Pelattu',
    'purchased': 'Ostettu',
};

const PlayableResults = ({ data, loading, onReturn }) => {
    const [user, setUser] = useState(null);

    if (user) {
        return (
            <User
                user={user}
                onReturn={() => setUser(null)}
            />
        );
    }

    const redeems = data ? data.items.map((item, index) => {
        const state = item.playable_ticket_state;
        let product = '';
        if(state.prize) {
            product = `${formatCurrency(state.prize)} €`;
        } else if(state.product_id) {
            product = `${item.prize_id}. ` +
                `${getLangValue(state.product_names, 'fi')} ` +
                `(${formatCurrency(state.product_value)} €) ` +
                `${state.product_option_names ? ` (${getLangValue(state.product_option_names, 'fi')})` : ''}`;
        } else {
            product = 'Lisäarvonta';
        }
        return {
            id: state.id,
            code_a: item.code_a,
            user_id: state.user_id,
            order_id: state.order_id,
            product: product,
            purchased_at: state.created_at,
            played_at: state.played_at,
            state: stateMap[item.state],
        };
    }) : [];

    return (
        <>
            <LoadingBar in={loading} />
            <Container>
                <Toolbar disableGutters>
                    <Typography
                        variant='h4'
                        noWrap
                        style={{ flexGrow: 1 }}
                    >
                        Pelattavat arvat
                    </Typography>
                    <Button variant='contained' color='primary' onClick={onReturn}>Haku</Button>
                </Toolbar>
                <Paper style={{ overflowX: 'auto' }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Arpanumero</TableCell>
                                <TableCell>Voitto</TableCell>
                                <TableCell>Tilausnumero</TableCell>
                                <TableCell>Tila</TableCell>
                                <TableCell>Aika (ostettu)</TableCell>
                                <TableCell>Aika (pelattu)</TableCell>
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {redeems.map((redeem) => (
                                <TableRow key={redeem.id}>
                                    <TableCell>{redeem.code_a}</TableCell>
                                    <TableCell>{redeem.product}</TableCell>
                                    <TableCell>{redeem.order_id}</TableCell>
                                    <TableCell>{redeem.state}</TableCell>
                                    <TableCell>{redeem.purchased_at ? moment.utc(redeem.purchased_at).local().format('DD.MM.YYYY HH:mm') : ''}</TableCell>
                                    <TableCell>{redeem.played_at ? moment.utc(redeem.played_at).local().format('DD.MM.YYYY HH:mm') : ''}</TableCell>
                                    <TableCell align='right'>
                                        <Button variant='contained' color='primary' onClick={() => {
                                            fetch(`${config.backendAddress}/api/v1/users/${redeem.user_id}?service=all`, {
                                                method: 'GET'
                                            })
                                                .then((response) => response.json())
                                                .then((json) => {
                                                    setUser(json);
                                                })
                                                .catch((error) => {
                                                    console.error(error);
                                                });
                                        }}>Lunastaja</Button>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </Paper>
            </Container>
        </>
    );
};

export default PlayableResults;
